import httpUserClient from '@/plugins/httpUserClient';

export default {
  getCoursesList(trainId) {
    return httpUserClient.get(`train/activities/${trainId}/schedules`);
  },
  attendanceCourse(id) {
    return httpUserClient.post(`user/train/schedules/${id}/attendances`);
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/userApis/train/userCourseApi.js